import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_16: FaireProductEntity = {
  token: "legacy_prod_abbott-16",
  type: "product",
  name: "White LED Taper Candle 9.5 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/021b7d4d38a9d9b43445388d50114511e81f38f4c06b3b99f7a81081219f1040.jpeg",
  priceDollars: 14,
  msrpDollars: 28,
  subcategory: "Taper Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
